import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {MORTGAGE_CATEGORY, newDesignInputCustomClassesViewOnly} from "../../../constants";
import {PercentageNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement/InputFormElement";
import {choiceValue, dateToMoment, momentToDate} from "../../utils";
import {END_DATE_SHOULD_BE_AFTER_START} from "../../../../Trades/constants";


const MortgageForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    sub_category: choiceValue(defaults.sub_category),
    name: defaults.name,
    company: defaults.company,
    address: defaults.address,
    value: decimalStrToNumber(defaults.value),
    interest_rate: decimalStrToNumber(defaults.interest_rate),
    start_date: dateToMoment(defaults.start_date),
    end_date: dateToMoment(defaults.end_date),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      start_date: momentToDate(model.start_date),
      end_date: momentToDate(model.end_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <SelectFormElementV2
            label="Kategorie"
            value={model.sub_category}
            options={MORTGAGE_CATEGORY.subCategories}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            required
            newDesign
            disabled={viewOnly}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label={'Gesellschaft'}
          value={model.company}
          error={errors.company}
          onChange={handleModelChange('company')}
          dataId={'company_name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Adresse / Flurstück"
          value={model.address}
          error={errors.address}
          onChange={handleModelChange('address')}
          dataId={'address-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Hypothekenhöhe"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          required={!viewOnly}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Zinssatz"
          inputComponent={PercentageNumberFormat}
          inputProps={{inputProps: {allowNegative: false, isAllowed: (values) => {
            const {floatValue} = values;
            return !floatValue || floatValue <= 100;
          }}}}
          value={model.interest_rate}
          error={errors.interest_rate}
          onChange={handleModelChange('interest_rate')}
          dataId={'interest_rate-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container spacing={1}>
          <Grid item xs>
            <CalendarFormElement
              label="Laufzeit von"
              value={model.start_date}
              error={errors.start_date}
              onChange={handleModelChange('start_date')}
              dataId={'start_date-input'}
              disabled={viewOnly}
              custom_classes={inputClasses}
            />
          </Grid>
          <Grid item xs={'auto'} style={{marginTop: viewOnly ? 26 : 32, padding: 0}}>–</Grid>
          <Grid item xs>
            <CalendarFormElement
              label="Laufzeit bis"
              value={model.end_date}
              error={errors.end_date}
              minDate={model.start_date || undefined}
              minError={END_DATE_SHOULD_BE_AFTER_START}
              onChange={handleModelChange('end_date')}
              dataId={'end_date-input'}
              disabled={viewOnly}
              custom_classes={inputClasses}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

MortgageForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default MortgageForm;